<header class="pn-header">
    <button (click)="handleOpenMenu()" class="hidden mb:block" type="button">
        <svg-icon
            [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"
            src="/assets/icons/menu.svg"
        ></svg-icon>
    </button>
    <div class="flex flex-col mb:hidden">
        <h3 class="text-nowrap text-xl font-bold text-neutral-09">
            {{ 'header.welcome' | translate }}, {{ session?.FullName }}
        </h3>
        <span class="text-nowrap text-sm font-normal text-neutral-06">
            {{ 'header.welcomeContent' | translate }}
        </span>
    </div>

    <div class="pn-header__right">
        <button
            class="language-btn nav-time-line"
            pnButton
            size="tiny"
            link
            status="primary"
            rounded="xs"
            aria-label="language button"
            [pnOverlay]="languageDropdown"
        >
            <img
                [src]="selectedLanguage.imageUrl"
                alt=""
                srcset=""
                class="h-[21.6px] w-[32.34px]"
            />
            <svg-icon src="/assets/icons/chevron-down.svg" svgClass="size-6" />
        </button>

        <div class="pn-header__divider">
            <div></div>
        </div>

        <div
            class="pn-header__user"
            cdkOverlayOrigin
            (click)="handleClickAvatar()"
            #trigger="cdkOverlayOrigin"
        >
            <div class="pn-header__user-avatar">
                <img [src]="session?.ProfilePictureUrl || '/assets/images/avatar.png'" alt="" />
            </div>

            <div class="pn-header__user-name">
                <h3>{{ session?.FullName }}</h3>
                <div class="user-wallet">
                    <svg-icon svgClass="size-4" src="/assets/icons/wallet-3.svg"></svg-icon>
                    <span>100.000.000 VND</span>
                </div>
            </div>
            <svg-icon
                class="mb:hidden"
                svgClass="icon:fill-primary-05 size-6"
                src="/assets/icons/chevron-down.svg"
            ></svg-icon>
        </div>
    </div>
</header>
<div
    class="dropdown-mobile"
    [ngClass]="{
        '!visible': isShowDrowdown(),
        '!invisible': !isShowDrowdown(),
    }"
>
    <ul
        class="dropdown-list"
        [ngClass]="{
            '!-translate-y-full': !isShowDrowdown(),
            '!translate-y-[0]': isShowDrowdown(),
        }"
    >
        <li
            class="!text-secondary-500"
            (click)="handleRedirectToProfile(); isShowDrowdown.set(false)"
        >
            <svg-icon svgClass="size-6" src="/assets/icons/wallet-3.svg"></svg-icon>
            199999999 VND
        </li>
        <li (click)="handleRedirectToProfile(); isShowDrowdown.set(false)">
            <svg-icon svgClass="size-6" src="/assets/icons/user.svg"></svg-icon>
            {{ 'header.account' | translate }}
        </li>
        <li (click)="handleOpenRequestCreditPopup(); isShowDrowdown.set(false)">
            <svg-icon svgClass="size-6" src="/assets/icons/moneys.svg"></svg-icon>
            {{ 'header.requestCredit' | translate }}
        </li>
        <li (click)="handleOpenChangePasswordPopup(); isShowDrowdown.set(false)">
            <svg-icon svgClass="size-6" src="/assets/icons/lock6.svg"></svg-icon>
            {{ 'header.changePass' | translate }}
        </li>
        <li (click)="handleLogout()">
            <svg-icon svgClass="size-6" src="/assets/icons/logout.svg"></svg-icon>
            {{ 'header.logOut' | translate }}
        </li>
    </ul>
    <div class="dropdown-backdrop" (click)="handleClickOutside($event)"></div>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen() && !isMobile()"
    [cdkConnectedOverlayOffsetY]="8"
    [cdkConnectedOverlayPanelClass]="['transition-all', 'ease-linear']"
    (overlayOutsideClick)="isOpen.set(false)"
    (detach)="isOpen.set(false)"
>
    <div class="dropdown">
        <ul class="flex flex-col">
            <li (click)="handleRedirectToProfile(); isOpen.set(false)">
                <svg-icon svgClass="size-6" src="/assets/icons/user.svg"></svg-icon>
                {{ 'header.account' | translate }}
            </li>
            <li (click)="handleOpenRequestCreditPopup(); isOpen.set(false)">
                <svg-icon svgClass="size-6" src="/assets/icons/moneys.svg"></svg-icon>
                {{ 'header.requestCredit' | translate }}
            </li>
            <li (click)="handleOpenChangePasswordPopup(); isOpen.set(false)">
                <svg-icon svgClass="size-6" src="/assets/icons/lock6.svg"></svg-icon>
                {{ 'header.changePass' | translate }}
            </li>
            <li (click)="handleLogout()">
                <svg-icon svgClass="size-6" src="/assets/icons/logout.svg"></svg-icon>
                {{ 'header.logOut' | translate }}
            </li>
        </ul>
    </div>
</ng-template>

<ng-template #languageDropdown>
    <ul class="dropdown">
        @for (item of languageOptions; track $index) {
            <li
                class="dropdown-item"
                (click)="changeLanguage(item)"
                [ngClass]="{ selected: selectedLanguage.code === item.code }"
            >
                <img [src]="item.imageUrl" alt="" srcset="" class="h-[21.6px] w-[32.34px]" />
                {{ item.title }}
            </li>
        }
    </ul>
</ng-template>
